/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import './../App.css'
import './groups.css'
import { useNavigate } from "react-router-dom";
import { buildHttpGet } from "./utils/backendInterface.js";
import { buildTable } from "./utils/table.js";
import { isDev } from "./utils/helper.js";
import { getCompanies } from "./utils/dataRequests";


const Groups = () => {
    const navigate = useNavigate();

    const [companyId, setCompanyId] = useState(() => {
        // Initialize from URL or sessionStorage
        let pathArray = window.location.pathname.split('/');
        if (pathArray.length > 2 && pathArray[1] === "companies" && pathArray[2] !== undefined) {
            sessionStorage.setItem("lastSelectedCompany", pathArray[2]);
            return pathArray[2];
        } else {
            return sessionStorage.getItem("lastSelectedCompany");
        }
    });

    // Keep these as regular variables since they don't trigger re-renders
    let count = 0;
    let _isDev = isDev();
    let accessToken = sessionStorage.getItem("accessToken");
    let groupsJson;
    let companiesJson;

    console.log('Groups page loaded. companyId: ' + companyId);

    function redirectToCreateGroup() {
        let createGroupButton = document.getElementById("create-group-button");
        if (createGroupButton && companyId !== undefined) {
            createGroupButton.href = "/create-group/" + companyId;
        } else {
            console.log("Unable to determine createGroupButton");
        }
    }

    function onCompanyChange() {
        console.log("onCompanyChange");
        let companyDropDownSelection = document.getElementById("company-drop-down-selection");

        if (companyDropDownSelection) {
            let newCompanyId = companyDropDownSelection.value;
            let newCompanyName = companyDropDownSelection.options[companyDropDownSelection.selectedIndex].text;
            console.log("Company ID selected. name: " + newCompanyName + " id: " + newCompanyId);
            if (companyId !== newCompanyId) {
                console.log("Company changed. name: " + newCompanyName + " id: " + newCompanyId);
                setCompanyId(newCompanyId); // Use setCompanyId instead of direct assignment
                sessionStorage.setItem("lastSelectedCompany", newCompanyId);
                navigate('/companies/' + newCompanyId + '/groups');
                displayGroups();
            }
        }
    }

    function displayCompanyDropDownJson() {
        if (!companiesJson) {
            console.log("Could not find any companies");
            alert("No companies could be found");
            return;
        }
        console.log("Companies: ");

        let companyDropDownContainer = document.getElementById("company-drop-down-container");
        let oldCompanyDropDownContainerSelection = document.getElementById("company-drop-down-selection");
        if (oldCompanyDropDownContainerSelection) {
            companyDropDownContainer.removeChild(oldCompanyDropDownContainerSelection);
        }
        let companyDropDownContainerSelection = document.createElement('select');
        companyDropDownContainerSelection.setAttribute("id", "company-drop-down-selection");
        companyDropDownContainerSelection.addEventListener("change", onCompanyChange);

        companiesJson.forEach(company => {
            if (company) {
                let optionCompanyName = company["name"];
                let optionCompanyId = company["_id"];
                if (optionCompanyName && optionCompanyId) {
                    console.log("optionCompanyName: " + optionCompanyName);
                    console.log("optionCompanyId: " + optionCompanyId);
                    let companyDropDownContainerOption = document.createElement('option');
                    let companyDropDownContainerOptionText = document.createTextNode(optionCompanyName);
                    companyDropDownContainerOption.appendChild(companyDropDownContainerOptionText);
                    companyDropDownContainerOption.value = optionCompanyId;
                    companyDropDownContainerOption.selected = optionCompanyId === companyId;
                    companyDropDownContainerOption.setAttribute("companyName", optionCompanyName);
                    companyDropDownContainerSelection.appendChild(companyDropDownContainerOption);
                }
            }
        });

        companyDropDownContainer.appendChild(companyDropDownContainerSelection);
    }

    function onGetCompanies(_companiesJson) {
        if (_companiesJson) {
            companiesJson = _companiesJson;
            if (companyId === undefined && companiesJson.length > 0) {
                setCompanyId(companiesJson[0]["_id"]); // Use setCompanyId
                sessionStorage.setItem("lastSelectedCompany", companiesJson[0]["_id"]);
                navigate('/companies/' + companiesJson[0]["_id"] + '/groups');
            } else {
                displayCompanyDropDownJson();
            }
        } else {
            // Handle case where no companies were returned
            companiesJson = []; // Set to empty array to prevent errors
            displayCompanyDropDownJson(); // This will show "No companies could be found" alert
        }
    }

    function displayCompanyDropDown() {
        getCompanies(onGetCompanies, accessToken);
    }

    function displayGroups() {
        redirectToCreateGroup();

        // First display the company drop down list
        displayCompanyDropDown();

        let requestParams = new Map();
        requestParams.set("accessToken", accessToken);

        if (companyId !== undefined) {
            function alertContents(httpRequest) {
                if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                    console.log("httpRequest.status: " + httpRequest.status);
                    if (httpRequest.status === 200) {
                        console.log("Got groups success");
                        console.log("Body: " + httpRequest.responseText);
                        groupsJson = JSON.parse(httpRequest.responseText);
                        buildTable("groups-container", ["Name", "Type"], ["name", "type"], groupsJson, navigate, "_id", '/companies/' + companyId + '/groups/');
                    } else if (httpRequest.status === 403) {
                        console.log("Get groups denied. Status: " + httpRequest.status + " Error: " + httpRequest.thrownError);
                        alert('Failed to get groups');
                    } else {
                        alert("There was a problem with the request: ", httpRequest.status);
                    }
                }
            }

            let httpRequest = buildHttpGet('companies/' + companyId + '/groups', requestParams, alertContents);
            httpRequest.sendRequest();
        }
    }

    useEffect(() => {
        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }
        if (!accessToken) {
            navigate('/sign-in');
            return;
        } else if (!sessionStorage.getItem("accessToken")) {
            return;
        }

        // Handle initial navigation if needed
        if (companyId && window.location.pathname !== `/companies/${companyId}/groups`) {
            console.log(`Re-navigation required to: /companies/${companyId}/groups`);
            navigate(`/companies/${companyId}/groups`);
        }

        console.log("On page load");

        let editCompanyLink = document.getElementById("edit-company-button");
        if(editCompanyLink && companyId) {
            editCompanyLink.href = "/create-company/" + companyId;
        }

        if (companyId) {
            displayGroups();
        }
    }, [count]);

    return (
        <>
            <h2>Groups</h2>
            <nav id="sidebarMenu" className="collapse d-lg-block sidebar bg-white">
                <div className="position-sticky">
                    <div className="list-group list-group-flush mx-3 mt-4">
                        <a id="edit-company-button" href="#" className="list-group-item list-group-item-action py-2 ripple" >
                            <i className="fas fa-lock fa-fw me-3"></i><span>Edit company</span>
                        </a>
                        <a id="create-group-button" href="#" className="list-group-item list-group-item-action py-2 ripple">
                            <i className="fas fa-lock fa-fw me-3"></i><span>Create group</span>
                        </a>
                    </div>
                </div>
            </nav >
            <div id="company-drop-down-container" />
            <div className="content-box">  {/* This creates the white box */}
                <div id="groups-container"></div>  {/* This just holds the table */}
            </div>
        </>
    );
}

export default Groups;